export default __webpack_public_path__ + "static/media/video.bda94fc6.mp4";